import { ModalLegal } from '@lideralia/alife-uikit/dist/organisms/Modals/Legal';
import React from 'react';

export const RGPDTemplate = (props) => <ModalLegal {...props} />;
